import { gql, useMutation } from "@apollo/client";

const addProtocolMutation = gql`
  mutation AddProtocol($name: String!, $description: String!) {
    addProtocol(name: $name, description: $description) {
      id
    }
  }
`;

export const useAddProtocol = () => {
  return useMutation(addProtocolMutation, { refetchQueries: ["protocols", "allProtocols"] });
};
